const Hero = require('../hero/script');

class ImpactHero extends Hero {

	constructor(el, params) {

		super(el);

		// element vars


	}

	// basemodule methods

	_domReady(){ super._domReady(); }

	_addListeners(){ super._addListeners(); }
	_removeListeners(){ super._removeListeners(); }

	//

	_show(){
		super._show();
	}

	_hide(){
		super._hide();
	}

	_enable(){ super._enable(); }
	_disable(){ super._disable(); }

	_domUpdate(){ super._domUpdate(); }
	_resize(){ super._resize(); }
}

module.exports = ImpactHero;
